import { useEffect } from "react";

/**
 * Loads Meta Pixel and/or Google Analytics 4 based on env vars:
 *   REACT_APP_META_PIXEL_ID
 *   REACT_APP_GA_MEASUREMENT_ID
 * Leave empty to disable.
 */
export default function Analytics() {
  useEffect(() => {
    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    // ----- Meta Pixel -----
    if (pixelId && !window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
    }

    // ----- Google Analytics 4 -----
    if (gaId && !window.gtag) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", gaId);
    }
  }, []);

  return null;
}
